import * as React from 'react'
import styled, { keyframes } from 'styled-components'

// Create an style for the component 
const LoadingWrapper = styled.section`
  width:20px;
  height:20px;
  z-index:99999;
  display: flex;
  justify-content: center;
  align-items: center;
  left:0;
  top:0;
`
const spin = keyframes`
  0% { transform: rotate(0deg) }
  100% {transform: rotate(360deg) }
`
const Circle = styled.div`
  border: 3px solid #143756;
  border-radius: 50%;
  border-top: 3px solid #ffffff;
  margin: auto;
  width: 20px;
  height: 20px;
  animation: ${spin} 2s linear infinite;
`

class Loading extends React.Component {

  render() {
    return (
      <LoadingWrapper>
        <Circle />
      </LoadingWrapper>

    )
  }
}

export { Loading }
